const ModeSelector = ({ mode, setMode, isMastering, setIsMastering }) => {
    return (
        <div style={{ display: 'flex', gap: '10px', margin: '10px 0' }}>
            {/* <button
                type="button"
                onClick={() => setMode('full')}
                style={{
                    padding: '8px 16px',
                    borderRadius: '20px',
                    backgroundColor: mode === 'full' ? '#4caf50' : '#ccc',
                    color: 'white',
                    border: 'none',
                    cursor: 'pointer'
                }}
            >
                Full
            </button>

            <button
                type="button"
                onClick={() => setMode('preview')}
                style={{
                    padding: '8px 16px',
                    borderRadius: '20px',
                    backgroundColor: mode === 'preview' ? '#2196f3' : '#ccc',
                    color: 'white',
                    border: 'none',
                    cursor: 'pointer'
                }}
            >
                Preview
            </button> */}
            
            <button
                onClick={() => setIsMastering(prev => !prev)}
                style={{ backgroundColor: isMastering ? '#FF9800' : '#ebebeb' }}
            >
                Mastering
            </button>
        </div>
    );
};
export default ModeSelector;